import React from "react"
import { Box, MenuItem, Typography } from "@mui/material"

import { FormikDropdown } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"

import { BillReceiversFormValuesType, CountryCode } from "../billReceiverTypes"

export function DetailsCountrySelect() {
    return (
        <Box>
            <LocalizedStrict id="bill-receivers-create-dialog-country">
                <Typography mb="1rem" variant="subtitle1" textAlign="start">
                    Country:
                </Typography>
            </LocalizedStrict>
            <FormikDropdown<BillReceiversFormValuesType> name="country" fullWidth>
                <MenuItem value={CountryCode.DA}>
                    <LocalizedStrict id="bill-receivers-form-country-select-da">
                        <span>Denmark</span>
                    </LocalizedStrict>
                </MenuItem>
            </FormikDropdown>
        </Box>
    )
}

